import { render, staticRenderFns } from "./RejectModal.vue?vue&type=template&id=1afb0223&scoped=true&"
import script from "./RejectModal.vue?vue&type=script&lang=js&"
export * from "./RejectModal.vue?vue&type=script&lang=js&"
import style0 from "./RejectModal.vue?vue&type=style&index=0&id=1afb0223&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb0223",
  null
  
)

export default component.exports